import React, { Component } from 'react';
import { connect } from 'react-redux';

class ErrorPage extends Component {
  shouldComponentUpdate(){
    return false;
  }
  componentDidMount() {
    const { mixpanel } = this.props;
    mixpanel.track('Error Page',{ action : 'browse' });
  }
  render() {
    return (
      <div>
        <p>No Match</p>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    mixpanel : state.ui.tempData.mixpanel
  }
}

export default connect(mapStateToProps,null)(ErrorPage)



/** WEBPACK FOOTER **
 ** ./src/containers/errorPage.js
 **/